import { readable, derived } from 'svelte/store'
import noop from 'lodash/noop';
import { getDepartments, getDepartmentHeads } from 'src/api'

export const Departments = readable([], (set) => {
  getDepartments().then(({ data }) => set(data));
  return noop;
})

export const DepartmentHeads = readable([], (set) => {
  getDepartmentHeads().then(({ data }) => set(data));
  return noop;
})

export const ParentDepartmentsMap = derived(Departments, departments => {
  const result = {};

  const traverse = (department, path = []) => {
    if (!department) return;
    result[department.id] = path;

    if (department.children) {
      department.children.forEach(department => traverse(department, [...path, department.id]));
    }
  };

  traverse(departments[0]);
  return result;
})
